import { useTranslation } from '../../contexts/LanguageContext'

interface CVLabelInputProps {
  value: string | undefined
  placeholder: string
  onChange: (value: string) => void
}

export function CVLabelInput({ value, placeholder, onChange }: CVLabelInputProps) {
  const { t } = useTranslation()

  return (
    <div className="flex items-center gap-1.5 mb-3">
      <svg className="w-3 h-3 text-slate-400 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
      </svg>
      <input
        type="text"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="text-xs text-slate-500 border-0 border-b border-dashed border-slate-300 bg-transparent px-0 py-0.5 focus:outline-none focus:border-primary placeholder:text-slate-400 w-full max-w-[200px]"
      />
      <span className="text-[10px] text-slate-400 whitespace-nowrap">{t.settingsForm.cvLabelHint}</span>
    </div>
  )
}
